import React, { useEffect } from "react";
import styles from "./NoticeMessage.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";

const successColor = "#f3fafa";
const errorColor = "#fff4f4";

type Props = {
  notice: { isShow: boolean; message: string; type: string };
  setNotice: React.Dispatch<React.SetStateAction<{ isShow: boolean; message: string; type: string }>>;
};

export const NoticeMessage = ({ notice, setNotice }: Props) => {
  const display = notice.isShow ? "block" : "none";
  const fontColor = notice.type === "notice" ? "#222222" : "#ff4958";
  const backgroundColor = notice.type === "notice" ? successColor : errorColor;
  useEffect(() => {
    if (notice.isShow) {
      const timer = setTimeout(() => {
        setNotice({ isShow: false, message: "", type: "" });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notice.isShow, setNotice]);

  return (
    <div
      className={styles.noticeWrap}
      style={{
        display: display,
        backgroundColor: backgroundColor,
      }}
    >
      <div className={styles.noticeContent}>
        <span data-testid="notice-message" style={{ color: fontColor }}>
          {notice.message}
        </span>
        <img
          src={getImageUrl("images/icons/cancel.svg")}
          className={styles.closeImg}
          onClick={() => setNotice({ isShow: false, message: "", type: "" })}
        />
      </div>
    </div>
  );
};
